import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import Loader from "../../../../Loader";
import PrintActions from "../../../../PrintActions";
import "../../../../AdminReportPrint.css";
import {reportRows} from "../../../../../utils/adminReportData";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";
import { Row, Col } from "react-bootstrap";
import idx from "indonesia-numbering-formatter";

import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Typography, Collapse, Box, Button, ButtonGroup, TextField } from "@material-ui/core";
import PaginationTable from "../../masterDropDown/PaginationTable";
import PaginationData from "../../../../../entity/PaginationData";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class RekapPenjualan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      isSnackbar: false,
      message: null,
      isOpenModal: false,
      namaProfil: null,
      listPenjualan: [],
      listHitungPenjualan: [],
      paginationData: PaginationData,
    };
  }

  async componentDidMount() {
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      this.fetchListPaketProgram();
    }
  }

  handleChangePage = async (newPage) => {
    this.state.paginationData.page = newPage;
    this.fetchListPaketProgram(this.state.namaProfil);
  };

  handleChangeRowsPerPage = (size) => {
    this.state.paginationData.page = 0;
    this.state.paginationData.size = size;
    this.fetchListPaketProgram(this.state.namaProfil);
  };

  render() {
    const { isFetching, listPenjualan } = this.state;
    return (
      <div className="wrapper admin-report-page admin-sales-report">
        {/* <LoaderModal isFetching={isFetching} /> */}
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          {this.loadSnackbar()}
          {this.modal()}
          <Navbar title={"Rekap Penjualan"} />
          <div className="admin-report-print-tools">
            <PrintActions disabled={isFetching || __.isEmpty(listPenjualan) || this.state.isOpenModal} />
            <p className="admin-report-print-hint">Mencetak data yang tampil di halaman ini.</p>
          </div>
          <Row>
            <Col sm={8}>
              <h4>LIST PROFIL {this.props.kodeTipeCbt}</h4>
            </Col>
            <Col sm={4} className="admin-print-no-output">
              <TextField id="namaPaketProgram" label="Cari Nama Paket Program" onChange={this.onChangeTextField} variant="outlined" />
            </Col>
          </Row>
          <Row>
            <Col>{isFetching && <Loader />} </Col>
          </Row>
          <Row>
            <Col>
              {!__.isEmpty(listPenjualan) && (
                <TableContainer component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Paket Program</TableCell>
                        <TableCell align="left">@Harga</TableCell>
                        <TableCell align="center" className="admin-print-no-output">#</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listPenjualan.map((pp, i) => (
                        <TableRow key={i}>
                          <TableCell>{pp.namaProgram}</TableCell>
                          <TableCell>Rp. {idx.format(pp.harga)}</TableCell>
                          <TableCell align="center" className="admin-print-no-output">
                            <Button color="primary" variant="outlined" onClick={() => this.openModal(pp.idPaketProgram)}>
                              <VisibilityOutlinedIcon fontSize="small" color="primary" />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <div className="admin-print-no-output">
                    <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                  </div>
                </TableContainer>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  openModal = async (idPaketProgram) => {
    this.setState({ isFetching: true });
    const result = await akmApi.get(URL_AKM.HITUNG_PENJUALAN_VOUCHER_BY_PP + idPaketProgram);
    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        console.log("OKE");
        this.setState({
          listHitungPenjualan: result.data.data.listPenjualan,
          totalPenjualan: result.data.data.totalPenjualan,
          detailPaketProgram: result.data.data.detailPaketProgram.namaProgram,
          isOpenModal: true,
        });
      } else {
        console.log("NOT");
        this.setState({
          isSnackbar: true,
          message: result.data.errorSchema.errorMessage,
          codeError: result.data.errorSchema.codeError,
        });
      }
      this.setState({ isFetching: false });
    }
  };

  modal() {
    const { isOpenModal, detailPaketProgram, totalPenjualan, listHitungPenjualan } = this.state;
    return (
      <Dialog maxWidth="lg" open={isOpenModal} onClose={() => this.setState({ isOpenModal: false })} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{detailPaketProgram}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Nomor Transaksi</TableCell>
                    <TableCell align="left">Keterangan</TableCell>
                    <TableCell align="left">Sisa Voucher</TableCell>
                    <TableCell align="left">Terpakai</TableCell>
                    <TableCell align="center">Harga</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listHitungPenjualan.map((list, i) => (
                    <TableRow key={i}>
                      <TableCell>{list.nomorTransaksi}</TableCell>
                      <TableCell>{list.keterangan}</TableCell>
                      <TableCell>{list.jumlahVoucher}</TableCell>
                      <TableCell>{list.jumlahTerpakai}</TableCell>
                      <TableCell>Rp. {idx.format(list.harga)}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell colSpan="3">&nbsp;</TableCell>
                    <TableCell>Total Pemasukan</TableCell>
                    <TableCell>Rp. {idx.format(totalPenjualan)}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }

  onChangeTextField = async (e) => {
    const id = e.target.id;
    const val = e.target.value;
    this.setState({ [id]: val });

    this.fetchListPaketProgram(val);
  };

  fetchListPaketProgram = async (namaProgram) => {
    this.setState({ isFetching: true, listPenjualan: [] });
    try {
    const result = await akmApi.post(URL_AKM.FETCH_PAKET_PROGRAM_AKTIF_LIST + "?page=" + this.state.paginationData.page + "&size=" + this.state.paginationData.size, {
      namaProgram: namaProgram,
    });
    if (!result || !result.data) throw new Error("Hasil rekap belum tersedia.");
    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listPenjualan: reportRows(result.data.data.content),
          paginationData: {
            ...this.state.paginationData,
            page: result.data.data.number,
            size: result.data.data.size,
            totalPages: result.data.data.totalPages,
            numberOfElements: result.data.data.numberOfElements,
            totalElements: result.data.data.totalElements,
          },
        });
      } else {
        this.setState({
          listPenjualan: [],
          paginationData: PaginationData,
          showAlert: true,
          resMessage: result.data.errorSchema.errorMessage,
          isSnackbar: true,
          message: result.data.errorSchema.errorMessage,
        });
      }
      this.setState({ isFetching: false });
    }
    } catch (error) {
      this.setState({listPenjualan: [], isSnackbar: true, message: "Data rekap belum dapat dimuat. Muat ulang lalu coba lagi."});
    } finally {
      this.setState({isFetching: false});
    }
  };

  loadSnackbar = () => {
    const { isSnackbar, codeError, message } = this.state;
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "",
          horizontal: "",
        }}
        open={isSnackbar}
        autoHideDuration={5000}
        onClose={() => this.setState({ isSnackbar: false })}
      >
        <Alert onClose={() => this.setState({ isSnackbar: false })} severity={codeError == "EP-000" ? "success" : "error"}>
          <b>{message}</b>
        </Alert>
      </Snackbar>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(RekapPenjualan);
